import { createFileRoute, useParams, useRouter } from '@tanstack/react-router';
import Authorized from '@/components/Authorized';
import ActivityDetail from '@/components/ActivityDetail';
import BackTo from '@/components/BackTo';
import { classes } from '@/util/component-utils';
import styles from './message.module.css';

const route = '/message/$activityId';
export const Route = createFileRoute(route)({
  component: MessageDetail,
})

const logRoute = () => {
  console.log("Message detail route");
}

function MessageDetail() {
    const { activityId } = useParams({ from: route });
    const backRouteFunc = () => router.history.back();
    const router = useRouter();
    logRoute();

    return (
        <Authorized>
            <BackTo route={backRouteFunc} label="Back to jump" />
            <div className={classes("scrolling-container", styles.draftCompetitionContainer)}>
                <ActivityDetail activityId={activityId} />
            </div>
        </Authorized>
    )
}
